module.exports = __webpack_public_path__ + "static/garador-9968a58210ad579e63cbfa2df9d0e487.png";